export default class {
	constructor(obj) {
		this.id = obj.id
		this.name = obj.name
		this.code = obj.code
	}
}



// WEBPACK FOOTER //
// ./src/sites/dto/DtoWatershed.js